import { useMutation, useQueryClient } from "react-query";
import { z } from "zod";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { ApiError, ApplicationZodSchema, allApplicationsKey } from "./useGetAllApplications";
import { oneApplicationKey } from "./useGetOneApplication";

const jsonLdHeaders = {
    "Content-Type": "application/ld+json",
    Accept: "application/ld+json",
};

type RotateApplicationSecretOptions = {
    id: string;
};

type RotatedApplication = z.infer<typeof ApplicationZodSchema>;

export const useRotateApplicationSecret = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation<RotatedApplication, ApiError, RotateApplicationSecretOptions>(
        async ({ id }) => {
            const response = await loggedInApiCall.post(`/api/integrations/applications/${id}/secrets`, undefined, {
                headers: jsonLdHeaders,
            });

            return ApplicationZodSchema.parse(response.data);
        },
        {
            onSuccess: (rotatedApplication) => {
                queryClient.invalidateQueries(allApplicationsKey);
                queryClient.invalidateQueries([oneApplicationKey, rotatedApplication.id]);
            },
        },
    );

    return mutation;
};
